// src/components/FAQItem.js
import React, { useState } from 'react';
import './FAQItem.css';
import minus from "../assets/lsicon_minus-outline.png"
import plus from "../assets/ei_plus.png"

const FAQItem = ({ question, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <div className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        <h4>{question}</h4>
        <span className="faq-toggle"><img className={`faq-toggle-img ${isOpen? 'minus':'plus'}`} src={isOpen ? minus : plus} alt='icon'/></span>
      </div>
      <div className="faq-answer">
        <div className="faq-answer-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FAQItem;